import React, { useEffect, useState } from 'react'
import Banner from './Banner'
import './About.css'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import SendIcon from '@mui/icons-material/Send';

const Disclaimer = ({ galleryRef, contactRef }) => {
    const pageName = "Disclaimer"

    return (
        <>
            <Banner pageName={pageName} />
            <section className='abt_cont'>
                <div className='container'>
                    <article>
                        <div className='d-flex mb-6 mt-3 flex-column align-items-end'>
                            <p className="text-muted mb-1">Effective Date: 8 August 2026</p>
                            <p className="text-muted">Last Updated: 8 August 2026</p>
                        </div>

                        <h1 className="text-center mb-5 uppercase fw-bold w-100 mt-4" style={{ color: "#5e79bc", lineHeight: "65px", textTransform: "uppercase", fontSize: "32px" }}>
                            Car Genie is a brand operated by BM Enterprises <br /> ("BM Enterprises", "we", "us", or "our").
                        </h1>

                        <h3 className="mb-5" style={{ color: "#6d6c6c", lineHeight: "50px", fontWeight: 300 }}>
                            The information provided on the Car Genie website is intended for general informational purposes and should not be considered a substitute for professional automotive inspection, diagnosis or advice.
                        </h3>

                        <h3 style={{ color: "#5e79bc" }}> <span>1.</span> Automotive Information </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            Information, recommendations, service descriptions, photographs, videos and other content displayed on this website are provided in good faith. However, vehicle requirements and repair solutions may vary depending on the make, model, age, condition, previous repairs, accident history and other factors.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            A final diagnosis, repair recommendation, cost or completion time can only be confirmed after appropriate inspection of the vehicle.
                        </p>

                        <h3 className='mt-5 w-100' style={{ color: "#5e79bc" }}> <span>2.</span> Estimates and Prices </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>Any prices, estimates or service costs displayed on the website are indicative unless specifically stated otherwise. </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }} className='mb-3'>
                            The final cost may vary based on:
                        </p>

                        <ul style={{ color: "#4b4a4a", lineHeight: "40px", fontSize: "18px" }} className='mb-5 w-100'>
                            <li>•⁠  Vehicle inspection findings</li>
                            <li>•⁠  Parts and material requirements</li>
                            <li>•⁠  Additional defects discovered during repair</li>
                            <li>•⁠  Customer-requested changes</li>
                            <li>•⁠  Manufacturer specifications</li>
                            <li>•⁠  Taxes and other applicable charges</li>
                        </ul>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            No online estimate shall be treated as a final quotation unless expressly confirmed by Car Genie
                        </p>

                        <h3 style={{ color: "#5e79bc" }}> <span>3.</span> Service Results </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            While Car Genie makes reasonable efforts to provide professional automotive services, certain outcomes may depend on the pre-existing condition of the vehicle and other factors beyond our reasonable control.
                        </p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            In particular, the condition of older, accident-damaged, modified or previously repaired vehicles may affect the final result.
                        </p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>4.</span> Insurance Claims </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie may assist customers with insurance-related processes where such assistance is requested.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>However, insurance claim approval, survey assessment, depreciation, deductions, exclusions, settlement amounts and other decisions are determined by the relevant insurance company or authorised surveyor.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie does not guarantee approval or settlement of any insurance claim.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>5.</span> Third-Party Products and Services </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Where third-party products, parts, services, payment platforms, insurance services or external links are used, their respective terms, warranties and policies may apply.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Car Genie is not responsible for matters exclusively controlled by such third parties.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>6.</span> Website Availability </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>We make reasonable efforts to keep the website accurate and available. However, we do not guarantee that the website will always be uninterrupted, error-free, completely accurate or free from technical issues.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>7.</span> External Links </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>The website may contain links to third-party websites or services. Such links are provided for convenience and do not necessarily constitute an endorsement or recommendation by Car Genie.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>8.</span> Limitation of Reliance </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>Customers should not rely solely on information available on this website when making decisions concerning vehicle safety, repairs or maintenance.</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}> For vehicle-specific matters, customers should contact Car Genie and arrange an appropriate inspection.</p>

                        <h3 style={{ color: "#5e79bc" }} className='mt-5'> <span>9.</span> Changes </h3>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>BM Enterprises reserves the right to modify, update or remove website content, services, prices or information at any time without prior notice</p>

                        <p style={{ color: "#4b4a4a", lineHeight: "33px", fontSize: "18px" }}>
                            Car Genie is a brand operated by BM Enterprises.
                        </p>
                    </article>
                </div>
            </section>

        </>
    )
}

export default Disclaimer